import React, { useEffect, useRef } from 'react';
import { BottomArrows } from './BottomArrows';
import { Slide } from './Slide';
import { ScrollFlex } from './SlideBox.styled';
import { SlideBoxWrapper } from './SlideBoxWrapper';
import { TopArrows } from './TopArrows';
import { getCustomWidths, getVisibleSlides } from './helpers';
import { useSlideBoxNav } from './useSlideBoxNav';
/**
 * @public
 */
export function SlideBox({
  children,
  visibleSlides,
  onSlideChange,
  slideSpacing,
  stretchHeight,
  layout,
  currentSlideOverride,
  arrowSizeOverride,
  arrowButtonVariation = 'white',
  arrowPosition = 'hide',
  slideScrollNum = 2,
  mobileSlideScrollNum = 1,
  overflowAllowancePxX = 0,
  overflowAllowancePxY = 4,
  overflowAllowancePxTop
}) {
  const childArray = React.Children.toArray(children);
  const ref = useRef();
  const {
    setCurrentSlide,
    currentSlide,
    onSlideChangeWrapper,
    arrowProps
  } = useSlideBoxNav({
    onSlideChange,
    currentSlideOverride,
    arrowSizeOverride,
    arrowButtonVariation,
    arrowPosition,
    childArray,
    slideScrollNum,
    mobileSlideScrollNum
  });
  useEffect(() => {
    setCurrentSlide(currentSlideOverride);
  }, [currentSlideOverride]);
  return React.createElement(SlideBoxWrapper, {
    arrowPosition: arrowPosition
  }, React.createElement(TopArrows, {
    arrowProps: arrowProps,
    arrowPosition: arrowPosition
  }), React.createElement(ScrollFlex, {
    "data-testid": 'slide-box',
    ref: ref,
    pt: `${overflowAllowancePxTop || overflowAllowancePxY}px`,
    mt: `-${overflowAllowancePxTop || overflowAllowancePxY}px`,
    pb: `${overflowAllowancePxY}px`,
    mb: `-${overflowAllowancePxY}px`,
    px: `${overflowAllowancePxX}px`,
    mx: `-${overflowAllowancePxX}px`
  }, childArray.map((item, index) => React.createElement(Slide, {
    key: item.props.key || `slide${index}`,
    width: layout ? getCustomWidths(layout.split('-'), index) : getVisibleSlides(visibleSlides),
    onSlideChange: onSlideChangeWrapper,
    slideSpacing: slideSpacing,
    stretchHeight: stretchHeight,
    index: index,
    content: item,
    isCurrentSlide: currentSlide === index,
    numSlides: childArray.length,
    slideBoxRef: ref,
    overflowAllowancePxX: overflowAllowancePxX
  }))), React.createElement(BottomArrows, {
    arrowProps: arrowProps,
    arrowPosition: arrowPosition
  }));
}